import Swiper from "swiper";
import { Autoplay, Pagination, A11y } from "swiper/modules";

const Init = function () {
    if (!document.getElementById('event')) return;

    const kvSwiper = new Swiper('.kv-slider', {
        modules: [Autoplay],
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        }
    });

    // KV カルーセルの一時停止/再生(WCAG 2.2.2 Pause, Stop, Hide)
    // prefers-reduced-motion 指定時は自動再生せず停止状態で起動する
    const kvToggle = document.querySelector('.kv-slider-toggle');
    if (kvToggle) {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let playing = !prefersReducedMotion;
        const applyKvState = () => {
            if (playing) {
                kvSwiper.autoplay.start();
            } else {
                kvSwiper.autoplay.stop();
            }
            kvToggle.classList.toggle('is-paused', !playing);
            kvToggle.setAttribute('aria-label', playing ? 'スライドショーを一時停止' : 'スライドショーを再生');
        };
        applyKvState();
        kvToggle.addEventListener('click', () => {
            playing = !playing;
            applyKvState();
        });
    }

    // 画像が複数枚のイベントではページ送りのドットが表示されるため、
    // キーボードでも操作できるよう A11y を有効にする(role / tabindex / ラベルが付与される)
    document.querySelectorAll('.recommend-slider').forEach((el) => {
        const pagination = el.querySelector('.swiper-pagination');
        new Swiper(el, {
            modules: [Pagination, A11y],
            slidesPerView: 1,
            spaceBetween: 0,
            pagination: {
                el: pagination,
                clickable: true,
            },
            a11y: {
                containerMessage: 'イベントの画像',
                paginationBulletMessage: '{{index}}枚目の画像を表示',
                slideLabelMessage: '{{index}}枚目 / 全{{slidesLength}}枚',
                firstSlideMessage: '最初の画像です',
                lastSlideMessage: '最後の画像です',
                prevSlideMessage: '前の画像',
                nextSlideMessage: '次の画像',
            },
            breakpoints: {
                829: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            },
        });
    });

    document.querySelectorAll('.others-image-slider').forEach((el) => {
        const pagination = el.querySelector('.swiper-pagination');
        new Swiper(el, {
            modules: [Pagination],
            slidesPerView: 1,
            pagination: {
                el: pagination,
                clickable: true,
            },
        });
    });

    initEventModals();
};

// Event ページ専用: アーカイブサムネイル → モーダル開閉
function initEventModals() {
    const root = document.getElementById('event');
    if (!root) return;

    const triggers = root.querySelectorAll('[data-modal-target]');
    if (!triggers.length) return;

    let lastFocusedTrigger = null;
    let currentModal = null;
    const archiveSwipers = new Map();

    const focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])';

    function ensureArchiveSwiper(modal) {
        const sliderEl = modal.querySelector('.modal-slider');
        if (!sliderEl) return;

        if (archiveSwipers.has(modal.id)) {
            archiveSwipers.get(modal.id).update();
            return;
        }

        const pagination = sliderEl.querySelector('.swiper-pagination');
        const swiper = new Swiper(sliderEl, {
            modules: [Pagination, Autoplay],
            speed: 1000,
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
        });
        archiveSwipers.set(modal.id, swiper);
    }

    function openModal(modal, trigger) {
        ensureArchiveSwiper(modal);
        modal.hidden = false;
        document.body.classList.add('is-hidden');
        lastFocusedTrigger = trigger;
        currentModal = modal;

        const closeBtn = modal.querySelector('.modal--close');
        (closeBtn || modal).focus();

        document.addEventListener('keydown', handleKeydown);
    }

    function closeModal() {
        if (!currentModal) return;
        currentModal.hidden = true;
        document.body.classList.remove('is-hidden');
        document.removeEventListener('keydown', handleKeydown);

        if (lastFocusedTrigger && typeof lastFocusedTrigger.focus === 'function') {
            lastFocusedTrigger.focus();
        }
        currentModal = null;
        lastFocusedTrigger = null;
    }

    function handleKeydown(e) {
        if (e.key === 'Escape') {
            e.preventDefault();
            closeModal();
            return;
        }
        if (e.key === 'Tab' && currentModal) {
            const focusables = currentModal.querySelectorAll(focusableSelector);
            if (!focusables.length) return;
            const first = focusables[0];
            const last = focusables[focusables.length - 1];
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    }

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            const targetId = trigger.getAttribute('data-modal-target');
            const modal = document.getElementById(targetId);
            if (modal) openModal(modal, trigger);
        });
    });

    // overlay クリック / close ボタンクリックで閉じる(data-modal-close="true" 属性で共通化)
    root.querySelectorAll('[data-modal-close]').forEach((el) => {
        el.addEventListener('click', closeModal);
    });
}

window.addEventListener("load", Init);
